// src/index.tsx
import React from "react";
import ReactDOM from "react-dom/client";

// Global style foundation (order matters):
import "./styles/fonts.css";
import "./styles/typography.css";
import "./styles/typography-classes.css";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./features/auth/context/AuthContext";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element not found");
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you pass a function, it will log metrics; otherwise it does nothing.
reportWebVitals();
